import actions from './memberManagement/actions'
import mutations from './memberManagement/mutations'
import getters from './memberManagement/getters'

const state = {
  activeBenefitCategoryIndex: 0,
  memberAddresses: [],
  memberAddressesLoading: true,
  memberUpdating: false,
  memberDetails: {
    member: {
      privacy: {
        firstName: '',
        lastName: '',
        middleInitial: '',
        suffix: '',
        line1: '',
        line2: '',
        line3: '',
        zipCode: '',
        city: '',
        state: '',
        county: '',
        phoneNumber: '',
        emailAddress: ''
      },
      additionalMemberInfo: {},
      relatedMembers: [],
      eligibility: [],
      locked: true
    },
    benefits: {
      benefitDisplayCategories: []
    },
    amountLimit: {
      decliningBalance: {
        benefitCategoryLimits: []
      },
      deductibleBalance: {}
    }
  },
  memberDetailsLoading: true,
  memberTransactionsForm: {
    userId: '',
    startDate: '',
    endDate: '',
    type: ''
  },
  memberTransactions: [],
  memberTransactionsLoading: true,
  memberTransactionDrafts: [],
  memberTransactionDetailsLoading: false,
  transactionSearch: {fromDate: '', toDate: '', transactionType: 'ALL', userId: '' }
}

export const memberManagement = {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
